<template>
  <import-charge-tab lob="IE" />
</template>

<script>
import importChargeTab from '@/components/Cargo/Job/importCharge/importChargeTab'

export default {
  name: 'ImportChargeIE',
  components: { importChargeTab }
}
</script>
